var _rect, _rect2, _path, _rect3, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmMicroDeposit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  viewBox: "0 0 72 72",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "#FFF",
  rx: 36
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 30,
  width: 28,
  height: 18,
  rx: 2.5,
  stroke: "#1a4b8c",
  strokeWidth: 1.8,
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 35h28",
  stroke: "#1a4b8c",
  strokeWidth: 1.8
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 38,
  width: 8,
  height: 5,
  rx: 1.5,
  stroke: "#1a4b8c",
  strokeWidth: 1.4,
  fill: "none"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 26,
  r: 6,
  fill: "#F7931A"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 44,
  y: 30,
  textAnchor: "middle",
  fontSize: 10,
  fontWeight: "bold",
  fill: "white",
  fontFamily: "Arial, sans-serif"
}, "\u20BF")));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmMicroDeposit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirm_micro_deposit.2e5d09275ab2e40a32ffbf12ab9de0ff.svg";